export default {
  editing_profile: null,
  editing_mission: null,
  isLoading : true,
  matcher_list_consultant_fetching : false,
  hasNotif: false,
  duplicateMissionData : null,
  currentFiscalYear: null,
}
